import Vue from "vue";

//<el v-track:arg="{...value}" ... />

Vue.directive("track", {
  bind(el, binding) {
    // linking the click `handler` to `el` so we can remove it in `unbind`
    // not sure this is the best way to do it... (since we need a closure for bindings)
    const handler = ((el as any).handler = () => {
      // TODO: use core service
      console.log(`TRACKING: arg:${binding.arg}, value: ${JSON.stringify(binding.value)}`);
    });
    el.addEventListener("click", handler);
  },
  unbind(el) {
    el.removeEventListener("click", (el as any).handler);
  },
});
